import { render, staticRenderFns } from "./StudentQuery.vue?vue&type=template&id=568604c6&"
import script from "./StudentQuery.vue?vue&type=script&lang=ts&"
export * from "./StudentQuery.vue?vue&type=script&lang=ts&"
import style0 from "./StudentQuery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports